export default "__VITE_ASSET__BMmKx9FV__"